<template>
  <RadioGroup v-model="modelValue" class="flex items-center">
    <RadioGroupLabel class="mr-2">Year:</RadioGroupLabel>
    <RadioGroupOption
      v-if="maxYear == undefined"
      v-slot="{ checked }"
      :value="''"
    >
      <span
        class="px-2 py-1 md:px-3 md:py-1.5 font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200"
        :class="checked ? 'bg-cardinal-500 text-white' : ''"
        >All</span
      >
    </RadioGroupOption>
    <RadioGroupOption
      v-for="year in years"
      :key="year"
      v-slot="{ checked }"
      :value="year"
    >
      <span
        class="px-2 py-1 md:px-3 md:py-1.5 font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200"
        :class="
          checked
            ? '!border-neutral-800 dark:!border-neutral-500 dark:text-white'
            : ''
        "
        >{{ year }}</span
      >
    </RadioGroupOption>
  </RadioGroup>
</template>

<script lang="ts" setup>
import { useVModels } from '@vueuse/core';
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';

export interface Props {
  modelValue: number;
  minYear?: number;
  maxYear?: number;
}

const props = withDefaults(defineProps<Props>(), {
  restricted: false,
  maxYear: 2025,
  minYear: 2021,
});

const emit = defineEmits(['update:modelValue']);
const { modelValue } = useVModels(props, emit);

const years = computed(() => {
  const currentYear = new Date().getFullYear();
  const startYear = props.minYear || currentYear - 5;
  const endYear = props.maxYear || currentYear;

  return Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => startYear + i
  ).reverse();
});

const onYearChange = (value) => {
  emit('update:modelValue', value);
};
</script>
